module.exports = __webpack_public_path__ + "media/fonts/Matter-Medium-d83f091bdabbbc210738971d4f0989dc.ttf";